import { useState } from "react";
import { Check, X, Edit2, Trash2 } from "lucide-react";

export const CompactGameRow = ({ game, showDate, dateLabel, dateCount, onEdit, onDelete, onUpdateResult }) => {
  const [editing, setEditing] = useState(false);
  const [homeScore, setHomeScore] = useState(game.home_score ?? "");
  const [awayScore, setAwayScore] = useState(game.away_score ?? "");

  const handleSave = () => {
    if (homeScore !== "" && awayScore !== "") {
      onUpdateResult(game, parseInt(homeScore), parseInt(awayScore));
      setEditing(false);
    }
  };

  return (
    <tr className="border-b border-zinc-800/50 hover:bg-zinc-800/30">
      {/* Date */}
      <td className="px-3 py-2">
        {showDate && (
          <div className="text-white text-xs font-medium">
            {dateLabel}
            {dateCount > 1 && <span className="text-zinc-500 ml-1">+{dateCount - 1}</span>}
          </div>
        )}
      </td>
      
      {/* Away Team */}
      <td className="px-3 py-2">
        <div className="flex items-center gap-2">
          {game.away_team_logo ? (
            <img src={game.away_team_logo} alt="" className="w-5 h-5 object-contain" />
          ) : (
            <div className="w-5 h-5 rounded bg-zinc-700 flex items-center justify-center text-[10px] font-bold text-white">
              {game.away_team?.charAt(0)}
            </div>
          )}
          <span className={`text-xs ${game.is_completed && game.away_score > game.home_score ? 'text-green-400 font-bold' : 'text-white'}`}>
            {game.away_team?.substring(0, 15)}{game.away_team?.length > 15 ? '...' : ''}
          </span>
        </div>
      </td>
      
      {/* Score */}
      <td className="px-3 py-2 text-center">
        {editing ? (
          <div className="flex items-center justify-center gap-1">
            <input
              type="number"
              value={awayScore}
              onChange={(e) => setAwayScore(e.target.value)}
              className="w-8 px-1 py-0.5 bg-zinc-800 border border-zinc-600 rounded text-white text-xs text-center"
              min="0"
              autoFocus
            />
            <span className="text-zinc-500 text-xs">-</span>
            <input
              type="number"
              value={homeScore}
              onChange={(e) => setHomeScore(e.target.value)}
              className="w-8 px-1 py-0.5 bg-zinc-800 border border-zinc-600 rounded text-white text-xs text-center"
              min="0"
            />
            <button onClick={handleSave} className="text-green-400 hover:text-green-300 ml-1">
              <Check className="w-3 h-3" />
            </button>
            <button onClick={() => setEditing(false)} className="text-zinc-400 hover:text-white">
              <X className="w-3 h-3" />
            </button>
          </div>
        ) : game.is_completed ? (
          <span className="text-white font-mono text-xs">
            {game.away_score} - {game.home_score}
          </span>
        ) : (
          <button
            onClick={() => setEditing(true)}
            className="text-zinc-500 hover:text-orange-400 text-xs"
          >
            vs
          </button>
        )}
      </td>
      
      {/* Home Team */}
      <td className="px-3 py-2">
        <div className="flex items-center gap-2">
          {game.home_team_logo ? (
            <img src={game.home_team_logo} alt="" className="w-5 h-5 object-contain" />
          ) : (
            <div className="w-5 h-5 rounded bg-zinc-700 flex items-center justify-center text-[10px] font-bold text-white">
              {game.home_team?.charAt(0)}
            </div>
          )}
          <span className={`text-xs ${game.is_completed && game.home_score > game.away_score ? 'text-green-400 font-bold' : 'text-white'}`}>
            {game.home_team?.substring(0, 15)}{game.home_team?.length > 15 ? '...' : ''}
          </span>
        </div>
      </td>
      
      {/* Time */}
      <td className="px-3 py-2 hidden md:table-cell">
        {game.is_completed ? (
          <span className="text-zinc-500 text-xs">Final</span>
        ) : game.is_live ? (
          <span className="px-1.5 py-0.5 bg-red-500 text-white text-[10px] font-bold rounded animate-pulse">LIVE</span>
        ) : (
          <span className="text-zinc-400 text-xs">{game.scheduled_time || "TBD"}</span>
        )}
      </td>
      
      {/* Tags */}
      <td className="px-3 py-2 hidden lg:table-cell">
        <div className="flex gap-1">
          {game.is_conference_game && (
            <span className="px-1 py-0.5 bg-orange-500/20 text-orange-400 text-[10px] rounded">C</span>
          )}
          {game.is_division_game && (
            <span className="px-1 py-0.5 bg-blue-500/20 text-blue-400 text-[10px] rounded">D</span>
          )}
        </div>
      </td>
      
      {/* Actions */}
      <td className="px-3 py-2">
        <div className="flex items-center justify-end gap-1">
          <button onClick={onEdit} className="p-1 text-zinc-400 hover:text-white hover:bg-zinc-700 rounded">
            <Edit2 className="w-3 h-3" />
          </button>
          <button onClick={onDelete} className="p-1 text-zinc-400 hover:text-red-400 hover:bg-red-500/20 rounded">
            <Trash2 className="w-3 h-3" />
          </button>
        </div>
      </td>
    </tr>
  );
};
